export {
  CrayonChicky as InteractiveChicky,
  type CrayonChickyProps as InteractiveChickyProps,
} from "@/components/mascots/CrayonChicky";
